import {
  secondaryNavigationHeight,
  showSecondaryNavigationMinBreakpoint,
} from '@modules/layout/layout/constants/layoutConstants';
import { makeStyles } from '@rbx/ui';

const useUnifiedTopNavigationStyles = makeStyles()((theme) => {
  const searchButtonSize = 40;
  return {
    searchButton: {
      width: searchButtonSize,
      height: searchButtonSize,
      padding: '8px 16px',
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('Medium')]: {
        marginRight: -4,
      },
    },

    rightContent: {
      display: 'flex',
      alignItems: 'center',
    },

    bottomWrapper: {
      height: secondaryNavigationHeight,
      backgroundColor: theme.palette.surface[0],
      [theme.breakpoints.down(showSecondaryNavigationMinBreakpoint)]: {
        height: 0,
        overflow: 'hidden',
      },
    },
  };
});

export default useUnifiedTopNavigationStyles;
